import React from 'react';
import PropTypes from 'prop-types';

const OpeningHoursMeta = ({
  monday,
  tuesday,
  wednesday,
  thursday,
  friday,
  saturday,
  sunday
}) => (
  <>
    {monday && <meta itemProp="openingHours" content={'Mo ' + monday} />}
    {tuesday && <meta itemProp="openingHours" content={'Tu ' + tuesday} />}
    {wednesday && <meta itemProp="openingHours" content={'We ' + wednesday} />}
    {thursday && <meta itemProp="openingHours" content={'Th ' + thursday} />}
    {friday && <meta itemProp="openingHours" content={'Fr ' + friday} />}
    {saturday && <meta itemProp="openingHours" content={'Sa ' + saturday} />}
    {sunday && <meta itemProp="openingHours" content={'Su ' + sunday} />}
  </>
);
OpeningHoursMeta.propTypes = {
  monday: PropTypes.string,
  tuesday: PropTypes.string,
  wednesday: PropTypes.string,
  thursday: PropTypes.string,
  friday: PropTypes.string,
  saturday: PropTypes.string,
  sunday: PropTypes.string
};

export default OpeningHoursMeta;
